import React from 'react';
import tinycolor from "tinycolor2";


export default class FixedSpeaker extends React.Component {
  
  colors = {
    text: window.theme.palette.background.txt || '#333333',
    background: window.theme.palette.background.paper,
    primary: window.theme.palette.primary.main,
    secondary: window.theme.palette.primary.main,
  };

  constructor() {
    super();
    this.primaryDarken = tinycolor(this.colors.primary).darken(5).toString();
  }

  showSpeaker = (e) => {
    console.log(e.screenX);
    
    window.entered = false;
    e.preventDefault();
    e.stopPropagation();
    window.sdk.emit('showSpeaker', {
      title: window.currentSpeaker.name,
      description: window.currentSpeaker.description,
      id: window.currentSpeaker.id,
      x: e.screenX,
      y: e.screenY,
      live: window.vod ? false : true
    });
    if(this.timeout)
      clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if(!window.entered)
        window.sdk.emit('hideSpeakerPopup');
    }, 2000)
  }
  
//style={{ background: `linear-gradient(to bottom, ${this.primaryDarken}, ${this.colors.primary} 50%)` }}
  render() {
    return (
      <div className="fixed-speaker empty" style={{ color: '#fff', backgroundColor: this.colors.secondary }}>
        <div className="fixed-speaker__img">
          <img className="img-fluid" src="/public/trans.png" />
        </div>
        <div onClick={ this.showSpeaker } className="fixed-speaker__content" style={{ cursor: 'pointer', background: `linear-gradient(to bottom, ${this.primaryDarken}, ${this.colors.primary} 50%)` }}>
          <h3 className="fixed-speaker__name"></h3>
          <p className="fixed-speaker__job"></p>
  
          <p className="fixed-speaker__group">
            <span className="fixed-speaker__grouptitle"></span>
            <span className="fixed-speaker__groupvalue"></span>
          </p>
  
          <p className="fixed-speaker__group">
            <span className="fixed-speaker__grouptitle"></span>
            <span className="fixed-speaker__groupvalue"></span>
          </p>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Player/FixedSpeaker.js